export const GET_LIST_ITEM_NAME = 'GET_LIST_ITEM_NAME'
export const GET_LIST_ITEM_NAME_SUCCESS = 'GET_LIST_ITEM_NAME_SUCCESS'
export const FILTER_ITEM_CODE = 'FILTER_ITEM_CODE'
export const CHANGE_ITEM_NAME = 'CHANGE_ITEM_NAME'

export const getListItemNameSuccess = (payload) => {
    return {
        type: 'GET_LIST_ITEM_NAME_SUCCESS',
        payload
    }
}

export const getListItemName = (payload) => {
    return {
        type: 'GET_LIST_ITEM_NAME',
        payload
    }
}

export const filterItemCode = (payload) => {
    return {
        type: 'FILTER_ITEM_CODE',
        payload
    }
}

export const onChangeItemName = (payload) => {
    return {
        type: 'CHANGE_ITEM_NAME',
        payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/getListItemName.js